import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgChevronDown(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M15.9999 18.7322L24.9999 9.73218L26.7677 11.4999L16.8838 21.3838C16.6494 21.6183 16.3314 21.75 15.9999 21.75C15.6684 21.75 15.3505 21.6183 15.116 21.3838L5.23218 11.4999L6.99995 9.73218L15.9999 18.7322Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgChevronDown);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
